module.exports = __webpack_public_path__ + "img/2f37d1c.jpg";